"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    defineLocale: function (locale, data) {
        return data;
    }
};
